export enum BasicComponentType {
  DEFAULT = 'default',
  ACTIVE = 'active',
  DISABLED = 'disabled',
}
